import { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { api } from '../services/api';
import './ClientDetailPage.css';

export default function ClientDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [tab, setTab]       = useState('contracts');
  const [error, setError]   = useState(null);

  useEffect(() => {
    api.get(`/clients/${id}`)
      .then(setClient)
      .catch(() => setError('Client not found.'));
  }, [id]);

  if (error) return <div className="detail-error">{error}</div>;
  if (!client) return <div className="detail-loading">Loading…</div>;

  return (
    <div className="client-detail">
      <div className="detail-header">
        <div>
          <button className="back-link" onClick={() => navigate('/clients')}>← Clients</button>
          <h2>{client.name}</h2>
          <span className={`badge ${client.isActive ? 'badge-active' : 'badge-inactive'}`}>
            {client.isActive ? 'Active' : 'Inactive'}
          </span>
        </div>
        <Link to={`/clients/${id}/edit`} className="btn-secondary">Edit</Link>
      </div>

      <div className="contact-card">
        <div className="contact-row"><span>Email</span><a href={`mailto:${client.email}`}>{client.email}</a></div>
        {client.company && <div className="contact-row"><span>Company</span><p>{client.company}</p></div>}
        {client.phone   && <div className="contact-row"><span>Phone</span><p>{client.phone}</p></div>}
        {client.notes   && <div className="contact-row"><span>Notes</span><p className="notes">{client.notes}</p></div>}
        <div className="contact-row"><span>Added</span><p>{new Date(client.createdAt).toLocaleDateString()}</p></div>
      </div>

      <div className="tabs">
        <button className={tab === 'contracts' ? 'tab active' : 'tab'} onClick={() => setTab('contracts')}>
          Contracts ({client.contracts.length})
        </button>
        <button className={tab === 'invoices'  ? 'tab active' : 'tab'} onClick={() => setTab('invoices')}>
          Invoices ({client.invoices.length})
        </button>
      </div>

      {tab === 'contracts' && (
        <div className="tab-content">
          {client.contracts.length === 0 ? (
            <div className="empty-tab">No contracts yet.</div>
          ) : (
            <table className="data-table">
              <thead><tr><th>Title</th><th>Status</th><th>Signed</th><th>Created</th></tr></thead>
              <tbody>
                {client.contracts.map(c => (
                  <tr key={c.id}>
                    <td>{c.title}</td>
                    <td><span className={`badge badge-${c.status.toLowerCase()}`}>{c.status}</span></td>
                    <td>{c.signedAt ? new Date(c.signedAt).toLocaleDateString() : <span className="muted">—</span>}</td>
                    <td>{new Date(c.createdAt).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {tab === 'invoices' && (
        <div className="tab-content">
          {client.invoices.length === 0 ? (
            <div className="empty-tab">No invoices yet.</div>
          ) : (
            <table className="data-table">
              <thead><tr><th>Description</th><th>Amount</th><th>Status</th><th>Due</th></tr></thead>
              <tbody>
                {client.invoices.map(i => (
                  <tr key={i.id}>
                    <td>{i.description}</td>
                    <td>${Number(i.amountDue).toFixed(2)}</td>
                    <td><span className={`badge badge-${i.status.toLowerCase()}`}>{i.status}</span></td>
                    <td>{new Date(i.dueDate).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
